import { render, staticRenderFns } from "./DepositoPage.vue?vue&type=template&id=72ad0642"
import script from "./DepositoPage.js?vue&type=script&lang=js&external"
export * from "./DepositoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports